import { useEffect } from 'react';

export const searchPageDocumentTitle = (page: string, query: string) => {
  const label = `${page} search`;
  const trimmedQuery = query.trim();

  if (!trimmedQuery) {
    return label;
  }

  return `"${trimmedQuery}" - ${label}`;
};

export const useAdminDocumentTitle = (title?: string) => {
  useEffect(() => {
    if (!title) {
      return;
    }

    const previousTitle = document.title;

    document.title = `${title} - Reposit Admin`;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
